// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-n_hw","advertDetailServiceList__header":"c-n_hx","advertDetailServiceList__list":"c-n_hy"};